module.exports = __webpack_public_path__ + "media/images/placeholders/entzug-0b42bc047cd732d76b23b96aeccd5690.jpg";